export interface IPlayer {
  id: string;
  name: string;
  currentPosition: string;
  note: string;
  tags: string[];
}

export interface ITellInput {
  playerId: string;
  behaviorIds: string[];
  results: string[];
  comment: string;
  createdAt: Date;
}

export class Storage {
  static getBehaviors() {
    return [
      { id: "1", name: "Staring", icon: "👁️" },
      { id: "2", name: "Talking", icon: "🗣️" },
      { id: "3", name: "Laughing", icon: "😂" },
      { id: "4", name: "Stoic", icon: "😐" },
      { id: "5", name: "Smooth bet", icon: "🎯💰" },
      { id: "6", name: "Rough bet", icon: "💥💰" },
      { id: "7", name: "Check immediately", icon: "🐇👉" },
      { id: "8", name: "Bet immediately", icon: "🐇💰" },
      { id: "9", name: "Bet after tank", icon: "🐢💰" },
      { id: "10", name: "Reraise after tank", icon: "🐢💰" },
      { id: "11", name: "Ostentatious", icon: "💎💰" },
      { id: "12", name: "Over Patient", icon: "🧘" },
      { id: "13", name: "Pause then check", icon: "⏸️👉", tags: ["Pause"] },
      { id: "14", name: "Check card slowly", icon: "🐢🃏", tags: ["Preflop"] },
      { id: "15", name: "Check card quickly", icon: "🐇🃏", tags: ["Preflop"] },
      { id: "16", name: "Not focus", icon: "😵" },
      { id: "17", name: "Not focus and then focus", icon: "🔄" },
      { id: "18", name: "Act relax", icon: "😎" },
      { id: "19", name: "Double check card", icon: "👀🔁" },
      { id: "20", name: "Touching chip OOT", icon: "🪙" },
      { id: "21", name: "Pause then bet", icon: "⏸️💰", tags: ["Pause"] },
      { id: "22", name: "Wow", icon: "😲" },
      { id: "23", name: "I have it", icon: "😎💸" },
    ];
  }

  static getResults() {
    return [
      {
        id: "1",
        name: "Value",
        icon: "💰",
      },
      { id: "2", name: "Bluff", icon: "🤷" },
      { id: "3", name: "Protection", icon: "🤷" },
      { id: "4", name: "Draw", icon: "🤷" },
      { id: "5", name: "Fold", icon: "🤷" },
      { id: "6", name: "Call", icon: "🤷" },
      { id: "7", name: "Raise", icon: "🤷" },
      { id: "8", name: "Strong", icon: "🤷" },
      { id: "9", name: "Marginal", icon: "🤷" },
      { id: "10", name: "Nut", icon: "🤷" },
      { id: "11", name: "Weak", icon: "🤷" },
      { id: "12", name: "Air", icon: "🤷" },
      { id: "13", name: "Missed Draw", icon: "🤷" },
    ];
  }

  static createPlayers(names: string) {}

  static getPlayers(): IPlayer[] {
    return localStorage.getItem("players")
      ? JSON.parse(localStorage.getItem("players") || "")
      : [];
  }

  static savePlayers(players: IPlayer[]) {
    localStorage.setItem("players", JSON.stringify(players));
  }

  static getTells() {
    return localStorage.getItem("tells")
      ? JSON.parse(localStorage.getItem("tells") || "")
      : [];
  }

  static addTell(tell: ITellInput) {
    const tells = this.getTells();
    tells.push(tell);
    localStorage.setItem("tells", JSON.stringify(tells));
  }
}
